import * as yup from "yup";

const levelsSchema = yup.object().shape({
  nivel: yup.number().required(),
  questions: yup
    .array()
    .of(yup.number().required())
    .required("Must have fields")
    .min(1, "Minimum of 1 field"),
});

const themeSchema = yup.object().shape({
  title: yup.string().required("Campo obrigatório"),
});

const schema = {
  pillarName: yup.string().required("Nome de pilar inválido"),
  numberOfThemes: yup
    .mixed()
    .oneOf(
      ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
      "Selecione uma opção"
    )
    .required("Selecione uma opção"),
  numberOfLevels: yup
    .mixed()
    .oneOf(["1", "2", "3", "4", "5"], "Selecione uma opção")
    .required("Selecione uma opção"),
  pillarText: yup.string().required("Campo obrigatório"),
  pillarImage: yup.string(),
  helpTitle: yup.string().required("Campo obrigatório"),
  helpText: yup.string().required("Campo obrigatório"),
  themes: yup
    .array()
    .of(themeSchema)
    .required("Campo obrigatório")
    .test(
      "themes-length",
      "O número de temas deve ser igual ao valor de numberOfThemes",
      function (themes) {
        const { numberOfThemes } = this.parent;
        return themes.length === Number(numberOfThemes);
      }
    ),
  levels: yup
    .array()
    .of(levelsSchema)
    .required("Campo obrigatório")
    .test(
      "levels-length",
      "O número de niveis deve ser igual ao valor de numberOfLevels",
      function (themes) {
        const { numberOfLevels } = this.parent;
        return themes.length === Number(numberOfLevels);
      }
    )
};

export const diagnosisEditSchema = yup.object().shape({
  name: yup.string().required("Campo obrigatório"),
  form: yup
    .array()
    .of(yup.object().shape(schema))
    .required("Must have fields")
    .min(1, "Minimum of 1 field"),
});
